import { Grid, Typography } from '@mui/material';

function PageHeader() {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Flow Custom
        </Typography>
        <Typography variant="subtitle2">
          Customize your flow appearance and branding
        </Typography>
      </Grid>
    </Grid>
  );
}

export default PageHeader;
